import type { MemberPermission } from '../base.d'
import http from '../client'
import type {
  CreateFolderCommand,
  FolderModule,
  FolderTreeDTO,
  UpdateFolderCommand,
} from './folder.d'

// const macroApis = {
//   listPlatformTree: '/cad/api/macro-folder/list-platform-macro-folder-tree',
//   listTree: '/cad/api/macro-folder/list-macro-folder-tree',
//   create: '/cad/api/macro-folder/create-macro-folder',
//   update: '/cad/api/macro-folder/update-macro-folder',
//   delete: '/cad/api/macro-folder/delete-macro-folder',
// }

// const windowMacroApis = {
//   listPlatformTree: '/cad/api/common-folder/list-platform-window-macro-folder-tree',
//   listTree: '/cad/api/common-folder/list-window-macro-folder-tree',
//   create: '/cad/api/common-folder/create-window-macro-folder',
//   update: '/cad/api/common-folder/update-window-macro-folder',
//   delete: '/cad/api/common-folder/delete-window-macro-folder',
// }

// const pageMacroApis = {
//   listPlatformTree: '/cad/api/common-folder/list-platform-common-folder-tree',
//   listTree: '/cad/api/common-folder/list-common-folder-tree',
//   create: '/cad/api/common-folder/create-common-folder',
//   update: '/cad/api/common-folder/update-common-folder',
//   delete: '/cad/api/common-folder/delete-common-folder',
// }

// const layoutApis = {
//   listPlatformTree: '/cad/api/common-folder/list-platform-two-d-layout-folder-tree',
//   listTree: '/cad/api/common-folder/list-two-d-layout-folder-tree',
//   create: '/cad/api/common-folder/create-two-d-layout-folder',
//   update: '/cad/api/common-folder/update-two-d-layout-folder',
//   delete: '/cad/api/common-folder/delete-two-d-layout-folder',
// }

// const mainImageApis = {
//   listPlatformTree: '/cad/api/common-folder/list-platform-main-image-folder-tree',
//   listTree: '/cad/api/common-folder/list-main-image-folder-tree',
//   create: '/cad/api/common-folder/create-main-image-folder',
//   update: '/cad/api/common-folder/update-main-image-folder',
//   delete: '/cad/api/common-folder/delete-main-image-folder',
// }
const enterpriseApis = {
  listPlatformTree: '/cad/api/common-folder/list-platform-common-folder-tree',
  listTree: '/cad/api/common-folder/list-common-folder-tree',
  create: '/cad/api/common-folder/create-common-folder',
  update: '/cad/api/common-folder/update-common-folder',
  delete: '/cad/api/common-folder/delete-common-folder',
  query: '/cad/api/common-folder/query-common-folder',
}

const platformApis = {
  listTree: '/cad/api/common-folder/list-platform-common-folder-tree',
  create: '/cad/api/platform-common-folder/create-folder',
  update: '/cad/api/platform-common-folder/update-folder',
  delete: '/cad/api/platform-common-folder/delete-folder',
  move: '/cad/api/platform-common-folder/move-folder',
  query: '/cad/api/platform-common-folder/query-folder',
}

// const apiMap: Record<FolderModule, typeof macroApis> = {
//   macro: macroApis,
//   windowMacro: windowMacroApis,
//   layout: layoutApis,
//   mainImage: mainImageApis,
//   pageMacro: pageMacroApis,
// }

const folderSourceMap: Record<FolderModule, string> = {
  macro: 'macro',
  windowMacro: 'window_macro',
  layout: 'two_d_layout',
  mainImage: 'main_image',
  pageMacro: 'page_macro',
  productManual: 'product_manual',
}

function createPlatformApi(folderModule: FolderModule) {
  const source = folderSourceMap[folderModule]
  function listFolderTree() {
    return http<FolderTreeDTO[]>({
      url: platformApis.listTree,
      data: { source },
    })
  }

  function createFolder(data: CreateFolderCommand) {
    return http<FolderTreeDTO>({
      url: platformApis.create,
      data: { ...data, source },
    })
  }

  function updateFolder(data: UpdateFolderCommand) {
    return http({
      url: platformApis.update,
      data: { ...data, source },
    })
  }

  function deleteFolder(id: number) {
    return http({
      url: platformApis.delete,
      data: { id, source },
    })
  }

  function moveFolder(id: number, parentId: number) {
    return http({
      url: platformApis.move,
      data: { id, parentId, source },
    })
  }

  function queryFolder(id: number) {
    return http({
      url: platformApis.query,
      data: { id, source },
    })
  }

  function verifyFolderExist(folderNames: string[]) {
    return http<number | undefined>({
      url: '/cad/api/common-folder/verify-folder-exist',
      data: { folderNames, source },
    })
  }

  function createCommonFolderByPath(folderNames: string[]) {
    return http<FolderTreeDTO>({
      url: '/cad/api/common-folder/create-common-folder-by-path',
      data: { folderNames, source },
    })
  }

  function listFolderByIds(ids: number[]) {
    return http({
      url: '/cad/api/platform-common-folder/list-folder-by-ids',
      data: { ids, source },
    })
  }

  return {
    listFolderTree,
    createFolder,
    updateFolder,
    deleteFolder,
    moveFolder,
    queryFolder,
    verifyFolderExist,
    createCommonFolderByPath,
    listFolderByIds,
  }
}

export function createFolderApi(folderModule: FolderModule, isPlatform = false) {
  if (isPlatform) {
    return createPlatformApi(folderModule)
  }
  const source = folderSourceMap[folderModule]
  function listFolderTree() {
    return http<FolderTreeDTO[]>({
      url: enterpriseApis.listTree,
      data: { source },
    })
  }

  function createFolder(data: CreateFolderCommand) {
    return http<FolderTreeDTO>({
      url: enterpriseApis.create,
      data: { ...data, source },
    })
  }

  function updateFolder(data: UpdateFolderCommand) {
    return http({
      url: enterpriseApis.update,
      data: { ...data, source },
    })
  }

  function deleteFolder(id: number) {
    return http({
      url: enterpriseApis.delete,
      data: { id, source },
    })
  }

  function moveFolder(id: number, parentId: number) {
    return http({
      url: '/cad/api/common-folder/move-folder',
      data: { id, parentId, source },
    })
  }

  function queryFolder(id: number) {
    return http({
      url: enterpriseApis.query,
      data: { id, source },
    })
  }

  function verifyFolderExist(folderNames: string[]) {
    return http<number | undefined>({
      url: '/cad/api/common-folder/verify-folder-exist',
      data: { folderNames, source },
    })
  }

  function createCommonFolderByPath(folderNames: string[]) {
    return http<FolderTreeDTO>({
      url: '/cad/api/common-folder/create-common-folder-by-path',
      data: { folderNames, source },
    })
  }

  function listFolderByIds(ids: number[]) {
    return http({
      url: '/cad/api/common-folder/list-folder-by-ids',
      data: { ids, source },
    })
  }

  return {
    listFolderTree,
    createFolder,
    updateFolder,
    deleteFolder,
    moveFolder,
    queryFolder,
    verifyFolderExist,
    createCommonFolderByPath,
    listFolderByIds,
  }
}

export function listUserSpaceRole(folderIds: number[]) {
  return http<{ folderId: number; memberPermission: MemberPermission }[]>({
    url: '/cad/api/folder/list-user-space-role',
    data: { folderIds },
  })
}

export async function getFolderPath(id: number, root: string) {
  const res = await http<any[]>({
    url: '/cad/api/common-folder/list-folder-by-ids',
    data: { ids: [id] },
  })
  const [folder] = res
  if (!folder) return []
  const folderList = [...folder.parent, folder]
  folderList[0].name = root
  return folderList.map(f => f.name) as string[]
}
